var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.5,
    height: 37.751,
    viewBox: "0 0 43.5 37.751",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1430",
    "data-name": "Tracciato 1430",
    d: "M28.438,8.608c1.6-1.2,2.719-2.037,3.6-2.578a3.1,3.1,0,0,1,1.452-.622,2.2,2.2,0,0,1,1.689.845,3.1,3.1,0,0,1,.373,1.535c.094,1.025.1,2.417.1,4.423v13.8c0,2.006,0,3.4-.1,4.423a3.1,3.1,0,0,1-.373,1.535,2.2,2.2,0,0,1-1.689.845,3.1,3.1,0,0,1-1.452-.622c-.876-.54-1.991-1.374-3.6-2.578L23.57,25.959v-13.7ZM38.9,26.306c0,1.8,0,3.274-.109,4.42a6.02,6.02,0,0,1-1.053,3.247,5.462,5.462,0,0,1-4.187,2.093,6.02,6.02,0,0,1-3.23-1.106c-1.018-.628-2.251-1.553-3.773-2.694l-.067-.05L21.4,28.4H17.822V35.4a4.5,4.5,0,1,1-9.007,0V28.261A9.295,9.295,0,0,1,10.444,9.815H21.4L26.483,6l.067-.05c1.522-1.142,2.755-2.066,3.773-2.694a6.02,6.02,0,0,1,3.23-1.106,5.462,5.462,0,0,1,4.187,2.093,6.019,6.019,0,0,1,1.053,3.247c.1,1.146.109,2.616.109,4.42a7.38,7.38,0,0,1,0,14.394Zm0-3.412a4.122,4.122,0,0,0,0-7.571ZM20.313,25.145V13.073H10.444a6.036,6.036,0,1,0,0,12.073ZM12.073,28.4V35.4a1.246,1.246,0,1,0,2.491,0V28.4Z",
    transform: "translate(-1.15 -2.15)",
    fill: "#14bf97",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAd);
export default __webpack_public_path__ + "static/media/ad.e3029c6aff1a4929e9fc56c98634151a.svg";
export { ForwardRef as ReactComponent };